import api from './api';
import { clearPendingPayment } from './pendingPayment';

const keyOf = (type) => (type === 'cart' ? 'booking_cart_id' : (type === 'main' ? 'booking_main_id' : 'booking_id'));

// ลิงก์หน้าสถานะการจอง (ประกอบเหมือน goToStatus ในหน้าชำระเงิน)
const statusPathOf = (pending, ref = {}) => {
  if (pending.type === 'cart') return `/once/cart-status/${pending.id}/${ref.transaction_no || ''}`;
  if (pending.type === 'main') return `/once/status/${ref.booking_id || ''}/${ref.booking_no || ''}?close_all=true`;
  return `/once/status/${pending.id}/${ref.booking_no || ''}`;
};

/**
 * ลูกค้ากดยกเลิกการจองที่รอชำระเงินเอง -- ใช้ร่วมกันทุกหน้า (ตะกร้า, รายการห้อง, แคมป์ปิ้ง)
 *
 * ห้ามลบตัวชี้การรอชำระทิ้งก่อนรู้ผลจากเซิร์ฟเวอร์ เดิมลบทุกกรณี พอเซิร์ฟเวอร์ไม่ได้ปล่อยห้อง
 * (เช่นตรวจสถานะการจ่ายเงินไม่ได้) รายละเอียดการรอชำระหายไป แต่ห้องยังถูกกันอยู่
 * ลูกค้าจองใหม่ก็เจอห้องไม่ว่าง และไม่มีทางกลับไปยกเลิกหรือจ่ายต่อ
 *
 * done(outcome, statusPath)
 *   'released' -- ปล่อยห้องแล้ว (หรือไม่มีอะไรกันอยู่แล้ว) ตัวชี้ถูกลบแล้ว
 *   'paid'     -- จ่ายสำเร็จไปแล้ว ยกเลิกไม่ได้ statusPath = หน้าสถานะการจอง (อาจเป็น null)
 *   'failed'   -- ยังไม่ได้ปล่อย ตัวชี้ยังอยู่ ให้ลูกค้าลองใหม่
 */
const releasePendingHold = (pending, done) => {
  const params = { [keyOf(pending.type)]: pending.id };
  const opts = { showError: false, forceCallbackError: true }; // เน็ตหลุดก็ต้องได้ callback ไม่งั้นปุ่มค้าง "กำลังยกเลิก"

  api.request('omise-payments/hold/release', (res, success) => {
    if (success && res?.paid) {
      // ถามลิงก์หน้าสถานะ แล้วค่อยลบตัวชี้
      api.request('omise-payments/hold', (h, ok) => {
        clearPendingPayment();
        done('paid', ok && h?.status_ref ? statusPathOf(pending, h.status_ref) : null);
      }, params, 'GET', opts);
      return;
    }
    if (success && res && (Number(res.released) > 0 || Number(res.found) === 0)) {
      clearPendingPayment();
      done('released');
      return;
    }
    done('failed');
  }, params, 'POST', opts);
};

export default releasePendingHold;
